import React from 'react';

import CompanyBillingMapForm from 'screens/components/CompanyBillingMapForm';

const CompanyBillingMapEditContainer = () => <CompanyBillingMapForm />;

export default CompanyBillingMapEditContainer;
